import { ServerExceptionCode, CurriculumType } from "./../commonui/utils/enum";
import { VuexModule, Module, getModule, Action, Mutation } from "vuex-module-decorators";
import { store } from "commonui";
import { ObjectiveService, ITreeNode } from "@/services/objective-manager";
import { CurrentContentDetailsForm } from "@/services/content";
import TitleListState from "./title-list";
import { VersionGroupModule } from "./versiongroup";

@Module({ namespaced: true, name: "ContentObjectiveState", store: store, dynamic: true })
export default class ContentObjectiveState extends VuexModule {
	public titleListModule = getModule(TitleListState);
	public treeLevel = 3;
	public isLoading: boolean = false;
	public objectiveIds: string[] = [];
	public objectiveTree: ITreeNode[] = [];
	public objectiveHasExposure: boolean = false;
	public objectiveList: string[] = [];
	public contentDetails: CurrentContentDetailsForm = {
		title: "",
		categoryId: 0,
		contentTypeId: 0,
		languageSkillId: 0,
		vcsLevelId: 0
	};

	@Mutation
	setVCSLevelUnits(value) {
		this.contentDetails = value;
	}

	@Mutation
	setObjectiveIds(value) {
		this.objectiveIds = value;
	}

	@Mutation
	async setObjectiveTree(children: ITreeNode[]) {
		this.objectiveTree = children;
	}

	@Mutation
	setObjectiveHasExposure(value) {
		this.objectiveHasExposure = value;
	}

	@Mutation
	setObjectiveList(value) {
		this.objectiveList = value;
	}

	@Action
	async postContentObjectives() {
		const {
			editedContentDetails: { curriculumType },
			editedContentId,
			editeContentSelectedChapterId
		} = this.titleListModule;

		// chapterId => "none" -> normal content, "all" -> parent content.
		const contentId =
			editeContentSelectedChapterId !== "none" && editeContentSelectedChapterId !== "all"
				? editeContentSelectedChapterId
				: editedContentId;

		const params = {
			objectiveIds: this.objectiveIds,
			contentId,
			versionGroupId:
				curriculumType == CurriculumType.GrapeSEED
					? VersionGroupModule.selectedGsVersion
					: VersionGroupModule.selectedLsVersion
		};
		this.setLoading(true);
		await ObjectiveService.createContentObjectives(params).catch(({ error_code, error_description }) => {
			const errorDescriptionPrefix = "Error:";
			const contentData =
				error_description.length > 0 ? error_description[0].replace(errorDescriptionPrefix, "") : "";

			switch (error_code) {
				case ServerExceptionCode.InvalidObjectiveRemovalException:
					this.setObjectiveList(JSON.parse(contentData));
					this.setObjectiveHasExposure(true);
					return false;
				default:
					return true;
			}
		});
		this.setLoading(false);
	}

	@Action
	async getContentObjectiveTree(contentId?) {
		const { vcsLevelId, curriculumType } = this.titleListModule.editedContentDetails;
		const params = {
			mustDeepest: true,
			level: this.treeLevel,
			startUnitId: vcsLevelId,
			endUnitId: vcsLevelId,
			versionGroupId:
				curriculumType == CurriculumType.GrapeSEED
					? VersionGroupModule.selectedGsVersion
					: VersionGroupModule.selectedLsVersion
		};
		this.setLoading(true);
		const response = await ObjectiveService.getObjectivesTree(params);
		this.setObjectiveTree(response.children);
		this.setLoading(false);
	}

	@Mutation
	setLoading(isLoading: boolean) {
		this.isLoading = isLoading;
	}
}

export const ContentObjectiveModule = getModule(ContentObjectiveState);
